import Vue from 'vue'
import Vuex from 'vuex'
import scrmModule from './modules/scrm'
import userModule from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },

  getters: {
  },

  mutations: {
  },

  actions: {
  },

  modules: {
    // 可以在这里添加其他模块
      scrm: scrmModule,
      user: userModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js